module.exports = __webpack_public_path__ + "img/聚合议价.1e0800fa.png";